export const currencies = [
    {
        value: 'RUB',
        label: '₽',
        name: 'Рубль',
        id: 1
    },
    {
        value: 'USD',
        label: '$',
        name: 'Доллар США',
        id: 2
    },
    {
        value: 'EUR',
        label: '€',
        name: 'Евро',
        id: 3
    },
    {
        value: 'CNY',
        label: '¥',
        name: 'Юань',
        id: 4
    },
];
export const transactionsType = [
    {
        value: 'INPUT',
        label: 'Ввод'
    },
    {
        value: 'OUTPUT',
        label: 'Вывод'
    },
    {
        value: 'TAX',
        label: 'Налог'
    },
    {
        value: 'COMMISSION',
        label: 'Комиссия'
    },
    {
        value: 'INCOME',
        label: 'Доход'
    },
    {
        value: 'BUY',
        label: 'Покупка'
    },
    {
        value: 'SELL',
        label: 'Продажа'
    },
    {
        value: 'AMORT',
        label: 'Амортизация'
    },
    {
        value: 'DIVIDEND',
        label: 'Дивиденд'
    },
    {
        value: 'COUPON',
        label: 'Купон'
    }
];
export const security_type_share = 'share'
export const security_type_bond = 'bond'
export const security_type_etf = 'etf'
export const security_type_selt = 'selt'
export const security_type_cc = 'cc'
export const securityType = [
    { value: security_type_share, label: 'Акции'},
    { value: security_type_bond, label: 'Облигации'},
    { value: security_type_etf, label: 'ETF/ПИФ'},
    { value: security_type_selt, label: 'Валюта'},
    { value: security_type_cc, label: 'Криптовалюта'}
]
export const chartColors = [
    "#4E5688",
    "#D85D6B",
    "#6CC5E9",
    "#BD69BE",
    "#FFC60B",
    "#B0F0B8",
    "#F58C19",
    "#47CAC0",
    "#F0C6E4",
    "#7B583D",
    "#BBE6F3",
    "#48A679",
    "#CBADF2",
    "#FFC60B",
    "#A1A7F2",
    "#838081",
    "#F5AF63",
    "#91B3CF",
    "#F2B7F2",
    "#8255AA",
    "#F5D3B3",
    "#E279BF",
    "#D4F49E",
    "#C3986B",
    "#AADC69",
    "#F4B3B9",
    "#353D4A",
    "#95EFE7",
];